import { Container } from "./styles";
import playStore from "../../assets/play_store.svg"
// import DownloadApp from '../../assets/download.webp'
import externalLink from "../../assets/external-link.svg"
import ScrollAnimation from "react-animate-on-scroll";


export function Project() {
  return (
    <Container id="project">
      <h2>My Projects</h2>
      <div className="projects">

        <ScrollAnimation animateIn="flipInX">
          <div className="project">
            <header>
              <svg width="50" xmlns="http://www.w3.org/2000/svg" role="img" viewBox="0 0 24 24" fill="none" stroke="#23ce6b" strokeWidth="1" strokeLinecap="round" strokeLinejoin="round">
                <title>Folder</title>
                <path d="M22 19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5l2 3h9a2 2 0 0 1 2 2z"></path>
              </svg>
              <div className="project-links">
                <a href="https://play.google.com/store/apps/details?id=com.vg.batteryreminder" target="_blank" rel="noreferrer">
                  <img src={playStore} alt="Battery Reminder" />
                </a>
              </div>
            </header>
            <div className="body">
              <h3>Battery Reminder</h3>
              <p>
                Check Android device battery health and set for alarm for min max battery charging percentage
              </p>
            </div>
            <footer>
              <ul className="tech-list">
                <li>Android</li>
                <li>Kotlin</li>
                <li>Java</li>
              </ul>
            </footer>
          </div>
        </ScrollAnimation>

        <ScrollAnimation animateIn="flipInX">
          <div className="project">
            <header>
              <svg width="50" xmlns="http://www.w3.org/2000/svg" role="img" viewBox="0 0 24 24" fill="none" stroke="#23ce6b" strokeWidth="1" strokeLinecap="round" strokeLinejoin="round"> <title>Folder</title> <path d="M22 19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5l2 3h9a2 2 0 0 1 2 2z"></path> </svg>
              <div className="project-links">
                <a href="https://play.google.com/store/apps/details?id=com.freya.products" target="_blank" rel="noreferrer">
                  <img src={playStore} alt="Freya" /></a>
                {/* <a href="https://vote.vinayaksingh.com" target="_blank" rel="noreferrer">
                  <img src={externalLink} alt="Visit site" />
                </a>  */}
                </div>
            </header>
            <div className="body">
              <h3>E-commerce app </h3>
              <p>E-commerce app for hospitals nurse to order needed products for their patients, develop using react native For Europe Region .</p>
            </div>
            <footer> <ul className="tech-list"> <li>React native</li> </ul></footer>
          </div>
        </ScrollAnimation>

        <ScrollAnimation animateIn="flipInX">
          <div className="project">
            <header>
              <svg width="50" xmlns="http://www.w3.org/2000/svg" role="img" viewBox="0 0 24 24" fill="none" stroke="#23ce6b " strokeWidth="1" strokeLinecap="round" strokeLinejoin="round"><title>Folder</title> <path d="M22 19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5l2 3h9a2 2 0 0 1 2 2z"></path> </svg>
              <div className="project-links">
                <a href="https://play.google.com/store/apps/details?id=com.zingthing.customer" target="_blank" rel="noreferrer">
                  <img src={playStore} alt="Zingthing" /> </a>
               
              </div>
            </header>
            <div className="body">
              <h3>E-commerce</h3>
              <p>
                E-commerce app for all type of products deliver at home.
              </p>
            </div>
            <footer>
              <ul className="tech-list">
                <li>React-Native</li>
              </ul>
            </footer>
          </div>
        </ScrollAnimation>


        <ScrollAnimation animateIn="flipInX">
          <div className="project">
            <header>
              <svg width="50" xmlns="http://www.w3.org/2000/svg" role="img" viewBox="0 0 24 24" fill="none" stroke="#23ce6b " stroke-width="1" stroke-linecap="round" stroke-linejoin="round" ><title>Folder</title><path d="M22 19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5l2 3h9a2 2 0 0 1 2 2z"></path></svg>
              <div className="project-links">
                <a href="https://play.google.com/store/apps/details?id=com.zingthing.supplier" target="_blank" rel="noreferrer">
                  <img src={playStore} alt="Zingthing Business" />
                </a>
              
              </div>
            </header>
            <div className="body">
              <h3>Ecommerce App</h3>
              <p> Ecommerce app for vendor or sellers to sell their products on zingthing platform</p>
            </div>
            <footer>
              <ul className="tech-list">
                <li>React-Native</li>
              </ul>
            </footer>
          </div>
        </ScrollAnimation>

        <ScrollAnimation animateIn="flipInX">
          <div className="project">
            <header>
              <svg width="50" xmlns="http://www.w3.org/2000/svg" role="img" viewBox="0 0 24 24" fill="none" stroke="#23ce6b" strokeWidth="1" strokeLinecap="round" strokeLinejoin="round">
                <title>Code</title>
                <path d="M22 19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5l2 3h9a2 2 0 0 1 2 2z"></path>
              </svg>
              <div className="project-links">
                <a href="https://play.google.com/store/apps/details?id=com.icebit.jiyasalesecomrjt" target="_blank" rel="noreferrer">
                  <img src={playStore} alt="Jiya Sales" />
                </a>
              </div>
            </header>
            <div className="body">
              <h3>Ecommerce App</h3>
              <p>Jiya sales and jiya business app is e-commerce for local imitation shops</p>
            </div>
            <footer>
              <ul className="tech-list">
                <li>React-Native</li>
              </ul>
            </footer>
          </div>
        </ScrollAnimation>

        <ScrollAnimation animateIn="flipInX">
          <div className="project">
            <header>
              <svg width="50" xmlns="http://www.w3.org/2000/svg" role="img" viewBox="0 0 24 24" fill="none" stroke="#23ce6b" strokeWidth="1" strokeLinecap="round" strokeLinejoin="round">
                <title>Folder</title>
                <path d="M22 19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5l2 3h9a2 2 0 0 1 2 2z"></path>
              </svg>
              <div className="project-links">
                <a href="https://play.google.com/store/apps/details?id=com.anandniketanbhadaj.skool360" target="\_blank" rel="noreferrer">
                  <img src={playStore} alt="Skool 360" />
                </a>
             </div>
            </header>
            <div className="body">
              <h3>School Management App</h3>
              <p>
                School management app for students with various functionalities.
              </p>
            </div>
            <footer>
              <ul className="tech-list">
                <li>Android</li>
              </ul>
            </footer>
          </div>
        </ScrollAnimation>
        
      <ScrollAnimation animateIn="flipInX">
          <div className="project">
            <header>
              <svg width="50" xmlns="http://www.w3.org/2000/svg" role="img" viewBox="0 0 24 24" fill="none" stroke="#23ce6b" strokeWidth="1" strokeLinecap="round" strokeLinejoin="round">
                <title>Folder</title>
                <path d="M22 19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5l2 3h9a2 2 0 0 1 2 2z"></path>
              </svg>
              <div className="project-links">
                <a href="https://apps.apple.com/gb/app/my-homefarm/id6443949604" target="\_blank" rel="noreferrer">
                  <img src={playStore} alt="My HomeFarm" />
                </a>
             </div>
            </header>
            <div className="body">
              <h3>My HomeFarm</h3>
              <p>
               App developed for company which produces devices like planets farming in home or office or personal area and user can select plants and device appropriate for that
              </p>
            </div>
            <footer>
              <ul className="tech-list">
                <li>React-Native</li>
              </ul>
            </footer>
          </div>
        </ScrollAnimation>

      </div>
    </Container>
  );
}